var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _BloodPressureMeasuredJournalEvent;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr, belongsTo } from "@ember-data/model";
import JournalEvent from "core/models/journal-event";
import { sortBy } from "core/utils/sort";
import tWithDefault from "core/utils/t-with-default";
import dayjs from "dayjs";
import { validateDate, validateInclusion, validateNumber, validatePresence } from "ember-changeset-validations/validators";
import IntlService from "ember-intl/services/intl";
import BloodPressureSessionStartedJournalEvent from "./blood-pressure-session-started-journal-event";
const SPLIT_DAY_HOUR = 12;
export const SystolicLoinc = "8480-6";
export const DiastolicLoinc = "8462-4";

//---- Automatically generated, don't update this part ----
let BloodPressureMeasuredJournalEvent = (_dec = attr("number"), _dec2 = attr("number"), _dec3 = attr("number"), _dec4 = attr("string"), _dec5 = attr("boolean", {
  allowNull: true
}), _dec6 = belongsTo("blood-pressure-session-started-journal-event", {
  async: false,
  inverse: "bloodPressureMeasuredJournalEvents"
}), _class = (_BloodPressureMeasuredJournalEvent = class BloodPressureMeasuredJournalEvent extends JournalEvent {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "systolicPressure", _descriptor, this);
    _initializerDefineProperty(this, "diastolicPressure", _descriptor2, this);
    _initializerDefineProperty(this, "heartRate", _descriptor3, this);
    _initializerDefineProperty(this, "source", _descriptor4, this);
    _initializerDefineProperty(this, "isComputedAverage", _descriptor5, this);
    _initializerDefineProperty(this, "bloodPressureSessionStartedJournalEvent", _descriptor6, this);
  }
  static validations(intl) {
    return {
      occurredAt: [validatePresence({
        presence: true,
        description: tWithDefault(intl, "validations.blood-pressure-measured-journal-event.occurred-at", "La date")
      }), validateDate({
        message: "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
        onOrAfter: new Date("01/01/1900")
      }), validateDate({
        message: "Cette donnée ne peut être déclarée plus de 50 ans en avance. Veuillez modifier la date",
        onOrBefore: dayjs().add(50, "years").toDate()
      })],
      systolicPressure: validateNumber({
        allowBlank: true,
        description: intl.t("validations.blood-pressure-measured-journal-event.systolic-pressure")
      }),
      diastolicPressure: validateNumber({
        allowBlank: true,
        description: intl.t("validations.blood-pressure-measured-journal-event.diastolic-pressure")
      }),
      heartRate: validateNumber({
        allowBlank: true,
        description: intl.t("validations.blood-pressure-measured-journal-event.heart-rate")
      }),
      source: validateInclusion({
        list: ["withings"],
        allowBlank: true,
        description: intl.t("validations.blood-pressure-measured-journal-event.source")
      })
    };
  }

  //---- End of generated code ----

  static get SPLIT_DAY_HOUR() {
    return SPLIT_DAY_HOUR;
  }
  get isAlertingJournalEvent() {
    return this.bloodPressureSessionStartedJournalEvent.isAlertingJournalEvent;
  }

  /**
   * returns The day the measure belongs to, based on the begining of the session
   */
  get sessionDay() {
    return this.bloodPressureSessionStartedJournalEvent.getSessionDay(this.occurredAt);
  }
  get isMorning() {
    return dayjs(this.occurredAt).get("hour") < SPLIT_DAY_HOUR;
  }

  /**
   * Return the index of this measure by morning or evening.
   */
  get indexByMoment() {
    const isMorning = this.isMorning;
    return this.bloodPressureSessionStartedJournalEvent.getMeasurementsOfSessionDay(this.sessionDay).filter(je => je.isMorning === isMorning).toSorted(sortBy("occurredAt")).indexOf(this) + 1;
  }
  get isEvening() {
    return !this.isMorning;
  }
  hasAlertForCode(code) {
    if (!code || !this.alertTriggeredJournalEvents.length) return false;
    return Boolean(this.alertTriggeredJournalEvents.find(alert => {
      return alert.code == code;
    }));
  }

  // ------------------------------
  // ---------- HELPERS -----------
  // ------------------------------

  /**
   * Create a date corresponding to the current session day and the moment of the day
   * @param sessionDay - The day of the session => 0, 1 or 2
   * @param measureIndex - Used to sort the measure of a session
   */
  static createMeasurementDate(startSessionDate, sessionDay, isMorning, measureIndex = 0) {
    const baseDate = dayjs(startSessionDate).add(sessionDay, "day");
    return isMorning ? dayjs(baseDate).startOf("day").add(1, "hour").add(measureIndex, "minute").toDate() : dayjs(baseDate).endOf("day").subtract(1, "hour").subtract(2 - measureIndex, "minute").toDate();
  }
}, _defineProperty(_BloodPressureMeasuredJournalEvent, "type", "blood-pressure-measured-journal-event"), _BloodPressureMeasuredJournalEvent), _descriptor = _applyDecoratedDescriptor(_class.prototype, "systolicPressure", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "diastolicPressure", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "heartRate", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "source", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "isComputedAverage", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "bloodPressureSessionStartedJournalEvent", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { BloodPressureMeasuredJournalEvent as default }; // DO NOT DELETE: this is how TypeScript knows how to look up your models.